module.exports = __webpack_public_path__ + "img/media-lock.f522bb7c.svg";